import React from "react";

export default function TermsOfUse() {
    const containerStyle = {
        fontFamily: '"Segoe UI", Arial, sans-serif',
        lineHeight: 1.6,
        color: "#222",
        backgroundColor: "#fafafa",
        margin: 0,
        padding: "2rem",
    };

    const titleStyle = { color: "#056b2f", fontSize: "1.8rem" };
    const subtitleStyle = {
        color: "#0a7a3f",
        fontSize: "1.2rem",
        marginTop: "1.5rem",
    };
    const strongStyle = { color: "#0b642e" };

    return (
        <div style={containerStyle}>
            <h1 style={titleStyle}>Conditions d’Utilisation</h1>
            <p>
                Bienvenue sur ImpactCar, propriété de <strong style={strongStyle}>ICC</strong>. L’application
                est exclusivement destinée aux membres de la communauté{" "}
                <strong style={strongStyle}>Impact Centre Chrétien (ICC)</strong> résidant au Canada.
            </p>

            <h2 style={subtitleStyle}>1. Objet</h2>
            <p>
                ImpactCar est une plateforme de covoiturage communautaire gratuite qui
                permet aux membres de partager des trajets entre eux.
            </p>

            <h2 style={subtitleStyle}>2. Gratuité</h2>
            <p>
                L’utilisation de l’application et la participation aux trajets sont
                entièrement gratuites. Aucun paiement ou compensation financière n’est
                exigé ou autorisé entre les membres.
            </p>

            <h2 style={subtitleStyle}>3. Responsabilité</h2>
            <p>
                ICC et ImpactCar ne sont pas responsables des incidents pouvant survenir
                lors des trajets (accidents, retards, pertes, etc.). Les utilisateurs
                sont invités à agir avec respect, prudence et courtoisie.
            </p>

            <h2 style={subtitleStyle}>4. Inscription</h2>
            <p>
                L’accès à l’application nécessite une inscription manuelle avec un
                numéro de téléphone valide et une adresse courriel. Les utilisateurs
                doivent fournir des informations exactes et les tenir à jour.
            </p>

            <h2 style={subtitleStyle}>5. Confidentialité</h2>
            <p>
                Les informations fournies sont traitées conformément à la Politique de
                Confidentialité d’ImpactCar.
            </p>

            <h2 style={subtitleStyle}>6. Suspension ou suppression de compte</h2>
            <p>
                ImpactCar se réserve le droit de suspendre ou de supprimer tout compte
                en cas d’utilisation abusive ou de non-respect des présentes conditions.
            </p>

            <h2 style={subtitleStyle}>7. Modifications</h2>
            <p>
                ICC peut modifier ces conditions à tout moment. Les utilisateurs seront
                notifiés de tout changement important.
            </p>

            <h2 style={subtitleStyle}>8. Contact</h2>
            <p>
                Pour toute question ou demande, veuillez nous écrire à :{" "}
                <a href="mailto:drephyx.yango@kconsulting.tech">drephyx.yango@kconsulting.tech</a>.
            </p>
        </div>
    )
}